// extracted by mini-css-extract-plugin
module.exports = {"discountButton":"PaymentDiscountSection_discountButton__aWZwI"};